import { getDownloadURL, ref, uploadBytesResumable } from "firebase/storage";
import { storage } from "../firebase/config";
import { v4 as uuidv4 } from "uuid";
import { Receipt } from "./Receipt";

export function uploadPicture(
  picture: File,
  setPictureUploaded: (pictureUploaded: boolean) => void,
  updateReceipt: (receipt: Partial<Receipt>) => void
) {
  const id = uuidv4();
  const fileRef = ref(storage, `receipt_pics/${id}`);
  const metadata = {
    contentType: picture.type,
    cacheControl: "public,max-age=604800", // 1 week
  };

  const uploadTask = uploadBytesResumable(fileRef, picture, metadata);

  uploadTask.on(
    "state_changed",

    (snapshot) => {
      // const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
      // setUploadProgress(progress);
    },

    (error) => {
      console.error("Upload error:", error);
      throw error;
    },

    async () => {
      const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
      updateReceipt({ pictureUrl: downloadURL });
      setPictureUploaded(true);
    }
  );
}
